import React from 'react'
import PropTypes from 'prop-types'
import { Percentage as PercentageDisplay } from '@morningtrain/react-displays'
import { useValue } from '@morningtrain/react-resources'
import * as UI from 'ui'

export default function WageRatio ({ targetName, ...props }) {
  const value = useValue(props.name, props.defaultValue)
  const target = useValue(targetName, props.defaultTargetValue || 0.25)

  let textColor = null

  if (value <= target) {
    textColor = 'green'
  }

  if (value > target) {
    textColor = 'red'
  }

  return (
    <UI.Text color={textColor}>
      <PercentageDisplay {...props} decimals={2} />
    </UI.Text>
  )
}

WageRatio.defaultProps = {
  targetName: 'target',
  ...PercentageDisplay.defaultProps
}

WageRatio.propTypes = {
  targetName: PropTypes.string,
  ...PercentageDisplay.propTypes
}
